import { FunctionComponent } from "react";
import { IBenhNhan } from "../models/DSBenhNhanKhamBenhModels";
import { handleConvertAddress } from "../../utils/AppFunction";
import { formatPatientRowData } from "../utils/Utils";
import { formatBirthdate } from "../../utils/FormatUtils";
import { CODE_DOI_TUONG } from "../../phan-he-tiep-nhan-thanh-toan/constants/PhanHeTiepNhan";

interface InfoPatientRightProps {
  benhNhanInfo: IBenhNhan | undefined;
}

const InfoPatientRight: FunctionComponent<InfoPatientRightProps> = ({ benhNhanInfo }) => {
  let { patient, visit } = benhNhanInfo?.thongTinKhamBenh || benhNhanInfo || {};

  const formatVisitObjectType = (visitObject: any) => {
		const isInsuranceObject = visitObject?.visitObjectTypeCode === CODE_DOI_TUONG.BAO_HIEM;
		const coveragePercent = visitObject?.bhytCoveragePercentage
			? `(${visit?.bhytCoveragePercentage ?? ''}%)`
			: '';

		return isInsuranceObject
			? `${visit?.visitObjectTypeName}${coveragePercent}`
			: `${visit?.visitObjectTypeName ?? '...'}`;
  };

  return (
    <>
      {benhNhanInfo ? (
        <div className="mw-100">
          <div className="text-break fw-500 p-1 text-end">
            <span className="text-uppercase fw-600 fs-7">
              {formatPatientRowData([
                patient?.personName,
                patient?.code,
                formatBirthdate({ day: patient?.dobDay, month: patient?.dobMonth, year: patient?.dobYear, ageText: patient?.ageText }),
                patient?.gender
              ], '|')}
            </span>
            <div className="text-truncate fs-7">
              <span className="fs-7">
                {formatVisitObjectType(visit)}
              </span>
              <span className="fs-7 ps-1">
                | {handleConvertAddress(patient)}
              </span>
            </div>
          </div>
        </div>
      ) : (
        <div className="info-patient spaces h-90"></div>
      )}
    </>
  );
};

export default InfoPatientRight;
